// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  width: 100%;
  margin-bottom: 25px;
}

.default-spacing {
  display: grid;
  gap: 25px;
}

.default-spacing::ng-deep > * {
  display: flex;
}

[app-product-widget] {
  height: auto;
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/search-page/components/search-page-results/search-page-results.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF","sourcesContent":[":host {\n  display: inline-block;\n  width: 100%;\n  margin-bottom: 25px;\n}\n\n\n.default-spacing {\n  display: grid;\n  gap: 25px;\n}\n.default-spacing::ng-deep > * {\n  display: flex;\n}\n\n[app-product-widget] {\n  height: auto;\n  margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
